import { MonoStat, Tile, type StatusPipStatus } from '@diwata/ironvale'
import type { OpsFeed } from '@/api/feeds'
import { UnavailableNote } from './shared'

/**
 * The business pulse — big quiet numbers from diwa's aggregate stats.
 * Numbers, not alarms: a red probe dims to warn at the tile edge.
 */
export function OpsTile({ feed }: { feed: OpsFeed }) {
  const primary = (feed.items ?? []).find((i) => i.stats) ?? feed.items?.[0]
  const stats = primary?.stats
  const status: StatusPipStatus =
    feed.status === 'unavailable' ? 'unavailable' : feed.status === 'degraded' ? 'warn' : 'ok'
  return (
    <Tile title="Ops" status={status} asOf={feed.asOf} href={primary?.link} linkLabel="stats">
      {feed.status === 'unavailable' || !stats ? (
        <UnavailableNote feed={feed} />
      ) : (
        <>
          <div className="ap-stat-row">
            <MonoStat value={stats.users_total} label="users" delta={`+${stats.signups_7d} 7d`} />
            <MonoStat value={stats.waitlist_total} label="waitlist" />
            <MonoStat
              value={stats.domains_total}
              label="domains"
              delta={`${stats.domains_published} published`}
            />
            <MonoStat value={stats.entities_24h + stats.signals_24h} label="rows / 24h" />
          </div>
          <p className="ap-tile-note">
            {feed.items.map((i) => `${i.name} ${i.status}`).join(' · ')}
          </p>
        </>
      )}
    </Tile>
  )
}
